export enum FeedbackType {
  TicketFeedback = 1,
  PurchaseOrder = 2,
}
